import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ArrowLeftCircle = ({ className }) => {
  return (
    <svg
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-arrow-left-circle', { [className]: className })}
    >
      <path
        d='M4.64645 9.64645C4.45118 9.84171 4.45118 10.1583 4.64645 10.3536L7.82843 13.5355C8.02369 13.7308 8.34027 13.7308 8.53553 13.5355C8.73079 13.3403 8.73079 13.0237 8.53553 12.8284L5.70711 10L8.53553 7.17157C8.7308 6.97631 8.7308 6.65973 8.53553 6.46447C8.34027 6.2692 8.02369 6.2692 7.82843 6.46447L4.64645 9.64645ZM20 9.5L5 9.5L5 10.5L20 10.5L20 9.5Z'
        fill='currentColor'
      />
      <circle cx='10' cy='10' r='9.5' transform='rotate(-180 10 10)' stroke='currentColor' />
    </svg>
  );
};

ArrowLeftCircle.propTypes = {
  className: PropTypes.string,
};

export default ArrowLeftCircle;
